import { render, staticRenderFns } from "./trasladosCedis.vue?vue&type=template&id=e8963bd2&scoped=true&"
import script from "./trasladosCedis.vue?vue&type=script&lang=js&"
export * from "./trasladosCedis.vue?vue&type=script&lang=js&"
import style0 from "./trasladosCedis.vue?vue&type=style&index=0&id=e8963bd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8963bd2",
  null
  
)

export default component.exports